import React from 'react';
import { formModes } from '../../constants';
import i18next from "../../i18n";
import { History } from '../helpers/History';
import { Svg } from '../Svg';
import { documentsRoutes } from '../../AppRoutes';
export function DocumentTitle(props) {
    const { formMode, title, documentType, status, states } = props;
    const statusLabel = states?.find(obj => obj.Value === status)?.Label ?? status;
    const configuration = documentsRoutes.find((item) => item.type === documentType);
    if (configuration) {
        return (
            <div className="title-main">
                <button type="button" className="btn btn-back" onClick={() => { History.push(configuration.parentUrl); }}>
                    <Svg src="/img/icn-backk.svg" />
                </button>
                <h1>{formMode !== formModes.create ? title : i18next.t(`documentForm.${documentType.replace(":", "_")}.initTitle`)} <label className="status-r main">{statusLabel}</label></h1>
            </div>
        );
    }
}